// Portfolio Drift & Rebalancing Alpha Auditor -- the PUBLIC page shell.
//
// Route target for /free-tools/portfolio-drift-auditor. Mirrors the
// PortfolioDiversificationCheckerPage chrome (background glow, Back to Home,
// brand anchor, shared footer). Deliberately NOT behind <ProtectedRoute>.

import { Link } from 'react-router-dom';

import Footer from '../../components/footer';
import { DriftAuditorDashboard } from './DriftAuditorDashboard';

export const DriftAuditorPage = () => {
    return (
        <div className="relative isolate min-h-screen flex flex-col bg-slate-100 dark:bg-slate-950 transition-colors duration-300">
            <div
                className="absolute inset-0 -z-10 overflow-hidden pointer-events-none"
                aria-hidden="true"
            >
                <div className="absolute top-[-10%] left-[-10%] w-[55%] h-[45%] bg-indigo-900/30 dark:bg-indigo-900/40 rounded-full blur-[120px]"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-[45%] h-[35%] bg-violet-700/20 dark:bg-violet-700/40 rounded-full blur-[100px]"></div>
            </div>

            <header className="container mx-auto w-full px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8">
                <div className="flex items-center justify-between gap-4">
                    <Link
                        to="/"
                        className="group inline-flex items-center gap-2 rounded-xl px-3.5 py-2
                                   text-sm font-semibold
                                   text-slate-700 dark:text-slate-200
                                   bg-white/70 dark:bg-white/5 backdrop-blur-sm
                                   border border-slate-200/80 dark:border-white/10
                                   shadow-sm
                                   hover:-translate-y-0.5 hover:border-indigo-400/70 hover:text-indigo-600 dark:hover:text-indigo-400
                                   transition-all duration-300
                                   focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-100 dark:focus-visible:ring-offset-slate-950"
                    >
                        <i
                            className="bx bx-left-arrow-alt text-xl transition-transform duration-300 group-hover:-translate-x-1"
                            aria-hidden="true"
                        ></i>
                        Back to Home
                    </Link>

                    <a
                        href="https://forge-ultra.ki-wealth.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-base sm:text-lg font-black tracking-tight text-slate-900 dark:text-white
                                   rounded-lg transition-opacity hover:opacity-80
                                   focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-100 dark:focus-visible:ring-offset-slate-950"
                    >
                        Forge{' '}
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-violet-300">
                            Ultra
                        </span>
                    </a>
                </div>
            </header>

            <main className="flex-1 w-full pt-2 sm:pt-4 pb-16 sm:pb-24">
                <DriftAuditorDashboard />
            </main>

            <Footer />
        </div>
    );
};
